import { X } from "lucide-react";
import { useEffect, useState } from "react";

function RandomCol(i) {
    const colors = [
        '#9333EA',
        '#FF6B6B',
        '#4ECDC4',
        '#FFA726',
        '#06B6D4',
        '#F59E0B',
        '#10B981',
        '#8B5CF6',
    ];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    
    return i==null? randomColor : colors[i];
}

const formatMonthYear = (timestamp) => {
    const date = new Date(timestamp);
    const month = date.toLocaleString('en-US', { month: 'short' }).toLowerCase();
    const year = date.getFullYear();
    return `${month} ${year}`;
};

const formatMilestoneName = (name = "") => {
    return name
        .toLowerCase()
        .replace(/[^a-z]/g, "");
};

const RenderView = ({ item, renderType, extraData, region }) => {
    if(renderType === 'tagFull'){
        return (
            <div style={styles.categoryItem}>
                <div style={{...styles.categoryIndicator, backgroundColor: RandomCol() }} />
                <div style={styles.categoryInfo}>
                    <span style={styles.categoryName}>{item?.tagName}</span>
                    <span style={styles.categoryScore}>{item?.count} mention{item?.count > 1? 's' : ''}</span>
                    {item?.percentileCity &&
                        <span style={styles.categoryPercentile}>{region?.city} Top {item?.percentileCity} %</span>
                    }
                    {item?.percentileState &&
                        <span style={styles.categoryPercentile}>{region?.state} Top {item?.percentileState} %</span>
                    }
                    {item?.percentileCountry && 
                        <span style={styles.categoryPercentile}>{region?.country} Top {item?.percentileCountry} %</span>
                    }
                    {item?.percentileGlobal && 
                        <span style={styles.categoryPercentile}>🌍 Top {item?.percentileGlobal} %</span>
                    }
                </div>
            </div>
        )
    }
    if(renderType === 'milestone'){
        return(
            <div style={styles.timelineItem}>
                <div style={styles.timelineIcon}>
                    <img
                        style={{ width: "100%", height: "100%", objectFit: 'cover'}}
                        src={`https://d2902n7npbzg1t.cloudfront.net/resources/${formatMilestoneName(item?.name)}.png`}
                        alt={item?.name}
                    />
                </div>
                <div style={styles.timelineContent}>
                    <span style={styles.timelineTitle}>{item?.name}</span>
                    <span style={styles.timelineDate}>{formatMonthYear(item?.date)}</span>
                </div>
            </div>
        )
    }
    if(renderType === 'validation'){
        return(
            <div>
                <div style={styles.verifiedTagHeader}>
                    <span style={styles.verifiedTagName}>{item?.tag}</span>
                </div>
                
                <div style={styles.tagMetrics}>
                    <div style={styles.tagMetric}>
                        <span style={styles.tagMetricLabel}>User Votes</span>
                        <span style={styles.tagMetricValue}>{extraData?.[item.tag?.replace(/\s/g, '').toLowerCase()] || '0'}</span>
                    </div>
                    <div style={styles.tagMetric}>
                        <span style={styles.tagMetricLabel}>AI Score</span>
                        <span style={styles.tagMetricValue}>{item?.confidence}</span>
                    </div>
                    <div style={styles.tagMetric}>
                        <span style={styles.tagMetricLabel}>Chat Examples</span>
                        <span style={styles.tagMetricValue}>{item?.example || '0'}</span>
                    </div>
                </div>
                
                <div style={styles.aiEvidenceSection}>
                    <span style={styles.aiEvidenceTitle}>AI Evidence:</span>
                    <p style={styles.aiEvidenceText}>
                        {item?.evidence || 'AI evidence has been kept hidden from public view'}
                    </p>
                </div>
            </div>
            
        )
    }
    return null;
};

export const ReputationMoreModal = ({ visible, handleClose, data, renderType, extraData, region }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
    
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    if (!visible) return null;

    return (
        <div style={styles.modalContainer}>
            <div style={styles.backdrop} onClick={handleClose}></div>
            <div style={{...styles.headerContainer, width: isMobile ? "95%" : '480px',}} onClick={(e) => e.stopPropagation()}>
                <div style={styles.header}>
                    <span style={styles.headerText}>More</span>
                </div>
                <button
                    onClick={handleClose}
                    style={styles.closeButton}
                >
                    <X size="28px" color={'#FFF'} />
                </button>
            </div>
            <div style={{...styles.container, width: isMobile ? "95%" : '480px',}} onClick={(e) => e.stopPropagation()}>
                {data?.map((item, index) => (
                    <div key={index} style={styles.content}>
                        <RenderView item={item} renderType={renderType} extraData={extraData} region={region} />
                    </div>
                ))}
            </div>
        </div>
    );
};

const styles = {
    modalContainer: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        zIndex: 1000,
    },
    backdrop: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
        backdropFilter: 'blur(17px)',
        WebkitBackdropFilter: 'blur(17px)',
        zIndex: 0
    },
    headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '10px',
        justifyContent: 'space-between',
        width: '100%',
        paddingTop: "5px",
        paddingBottom: "5px",
        paddingLeft: "0px",
        paddingRight: "0px",
        zIndex: 1000,
    },
    container: {
        width: '100%',
        zIndex: 1000,
        marginTop: '10px',
        flex: 1,
        display: 'flex',
        overflowY: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        flexDirection: 'column'
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    headerContent: {
        flex: 1,
    },
    title: {
        fontSize: '22px',
        color: '#212529',
        marginBottom: '3px',
    },
    closeButton: {
        display: 'flex',
        width: '28px',
        height: '28px',
        backgroundColor: "rgba(255, 255, 255, 0.25)",
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '1000px',
        borderColor: 'transparent',
        zIndex: 9999,
        cursor: 'pointer'
    },
    headerText: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#FFF',
    },
    editHeader: {
        overflow: 'hidden',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        alignItems: 'center',
    },
    content: {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '12px',
        paddingRight: '12px',
        marginBottom: '6px',
        borderRadius: '12px',
        borderWidth: '1px',
        borderColor: 'rgba(255,255,255,0.7)',
        borderStyle: 'solid',
        
    },
    categoryItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    categoryIndicator: {
        width: '4px',
        borderRadius: '2px',
        marginRight: '11px',
        alignSelf: "stretch",
        transform: "scaleY(0.8)",
        transformOrigin: "center",
    },
    categoryInfo: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        marginLeft: '5px'
    },
    categoryName: {
        fontSize: '15px',
        color: '#fff',
        fontWeight: '600',
        marginBottom: '2px',
    },
    categoryScore: {
        fontSize: '13px',
        color: '#25ebddff',
        marginBottom: '2px',
    },
    categoryPercentile: {
        fontSize: '11px',
        color: '#25ebddff',
        fontWeight: '600',
    },
    timelineItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
    },
    timelineIcon: {
        width: '32px',
        height: '32px',
        borderRadius: '18px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '10px',
    },
    timelineContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        marginLeft: '5px'
    },
    timelineTitle: {
        fontSize: '15px',
        color: '#fff',
        fontWeight: '600',
        marginBottom: '2px',
    },
    timelineDate: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.7)',
    },
    verifiedTagHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '6px',
    },
    verifiedTagName: {
        fontSize: '14.5px',
        fontWeight: 'bold',
        color: '#fff',
    },
    verificationBadges: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
    },
    veracityBadge: {
        paddingHorizontal: '8px',
        paddingVertical: '4px',
        borderRadius: '8px',
    },
    highlyVerified: {
        backgroundColor: 'rgba(16, 185, 129, 0.8)',
    },
    veracityBadgeText: {
        fontSize: '10px',
        color: '#fff',
        fontWeight: '600',
    },
    aiConfidence: {
        fontSize: '12px',
        color: '#10B981',
        fontWeight: '600',
    },
    tagMetrics: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginBottom: '6px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '10px',
        paddingBottom: '5px',
        paddingTop: '5px',
    },
    tagMetric: {
        alignItems: 'center',
        flexDirection: 'column',
        display: 'flex'
    },
    tagMetricLabel: {
        fontSize: '10px',
        color: 'rgba(255, 255, 255, 0.7)',
        marginBottom: '2px',
    },
    tagMetricValue: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: '#fff',
    },
    aiEvidenceSection: {
        backgroundColor: 'rgba(147, 51, 234, 0.1)',
        borderRadius: '10px',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingBottom: '3px',
        paddingTop: '3px',
        borderWidth: '1px',
        borderColor: 'rgba(147, 51, 234, 0.3)',
        textAlign: 'left'
    },
    aiEvidenceTitle: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#C084FC',
    },
    aiEvidenceText: {
        fontSize: '11px',
        color: 'rgba(255, 255, 255, 0.8)',
        lineHeight: '13px',
    },
};